module.exports = __webpack_public_path__ + "static/media/district0x.75a5fdd2.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/coins/district0x.svg
// module id = 1140
// module chunks = 0